import type { IDropdownOption } from "@fluentui/react";
import { IPastPeriodInterval } from "@cayo/shared/api/types/cayo-graph";

export const numbers: IDropdownOption[] = [
  { key: 1, text: "1" },
  { key: 2, text: "2" },
  { key: 3, text: "3" },
  { key: 4, text: "4" },
  { key: 5, text: "5" },
  { key: 6, text: "6" },
  { key: 7, text: "7" },
  { key: 8, text: "8" },
  { key: 9, text: "9" },
  { key: 10, text: "10" },
  { key: 11, text: "11" },
  { key: 12, text: "12" },
];

export const types: IDropdownOption[] = [
  { key: "lastWeeksInterval", text: "Weeks" },
  { key: "lastMonthsInterval", text: "Months" },
];

export const pastPeriodsTypes = ["cayo.graph.lastWeeksInterval", "cayo.graph.lastMonthsInterval"];

export const pastPeriodMap = {
  lastWeeksInterval: "week",
  lastMonthsInterval: "month",
};

export function retrievePastPeriodData(interval: IPastPeriodInterval) {
  if (!interval.objectType) {
    return null;
  }
  const type = interval.objectType.split(".");
  return {
    number: interval.number,
    type: type[type.length - 1],
  };
}
